// import React, { useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { Typography } from "../components/UI/Typography";

// import {
//   ArchiveSection,
//   IntroSection,
// } from "../components/layout/ArticlesPage";

// export const ArticlesPage = ({ allPosts }) => {
//   const location = useLocation();

//   useEffect(() => {
//     const hash = location.hash; // Get the hash from the URL
//     if (hash) {
//       const element = document.querySelector(hash);
//       const offset = 100;
//       const elementPosition =
//         element.getBoundingClientRect().top + window.scrollY;
//       window.scrollTo({
//         top: elementPosition - offset, // Scroll to 100px above the element
//         behavior: "smooth",
//       });
//     }
//   }, [location]);

//   return (
//     <div className="bg-beige-prim pt-20 md:pt-28">
//       <IntroSection />
//       <section
//         id="articles_archieve_section"
//         className="articles_archieve_section bg-beige-sec pt-5 px-4 md:px-20"
//       >
//         <Typography variant="h1">PAST ISSUES</Typography>
//         <ArchiveSection allPosts={allPosts} />
//       </section>
//     </div>
//   );
// };
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Typography } from "../components/UI/Typography";
import {SubscribeSuccessPopup} from "../components/UI/SubscribeSuccessPopup";

import {
  ArchiveSection,
  IntroSection,
} from "../components/layout/ArticlesPage";

export const ArticlesPage = ({ allPosts }) => {
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);

  const handleSubscribeSuccess = () => {
    setShowPopup(true);
  };

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      const offset = 100;
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth",
      });
    }
  }, [location]);

  return (
    <div className="bg-beige-prim pt-20 md:pt-28">
      <IntroSection onSubscribeSuccess={handleSubscribeSuccess} />

      <section
        id="articles_archieve_section"
        className="articles_archieve_section bg-beige-sec pt-5 px-4 md:px-20"
      >
        <Typography variant="h1">PAST ISSUES</Typography>
        <ArchiveSection allPosts={allPosts} />
      </section>

      {showPopup && (
        <SubscribeSuccessPopup onClose={() => setShowPopup(false)} />
      )}
    </div>
  );
};
